import { browserHistory } from "react-router";
import { Toast } from "antd-mobile";
import Utility from "UTIL/utility";
import $ from "jquery";
import nodeConfig from 'MODEL/config';
import fingerPrint from 'UTIL/fingerPrint';

var _domain = "";
if (__DEV__) {
  _domain = nodeConfig.devGatewayAddress;
} else {
  _domain = Utility.getOrigin() + "/" + nodeConfig.gatewayApiAdress;
}

class GatewayApiService {
  apiServiceMethod(apimodule, apiname, type, params, needStatus) {
    Toast.loading('',0);
    const deferred = $.Deferred();
    if (!$(".modal-cover")[0]) {
      $("body").append('<div class="modal-cover"></div>');
    }
    let service = params.service;
    if(service) {
        // delete params.service;
    }
    let parameters = {param: params}
    const domain = _domain;

    var method = type.toUpperCase();
    if (["GET", "PUT", "POST", "DELETE", "OPTIONS"].indexOf(method) === -1) {
      return;
    }

    var finalUrl =
      domain +
      "/" +
      (apimodule == "" ? "" : apimodule + "/") +
      (apiname == "" ? "" : apiname);
    var queryString = [];
    var postdata;
    var i = 0;
    var len = parameters ? Object.keys(parameters).length : 0;

    if (method == "POST" || method == "PUT") {
      postdata = params;
    }
    if (parameters) {
      for (let x in parameters) {
        i++;
        if (i == len && typeof parameters[x] == "object") {
          postdata = JSON.stringify(parameters[x]);
          continue;
        }
        if (!parameters[x]) {
          continue;
        }
        queryString.push(x + "=" + encodeURI(parameters[x]));
      }
      if (queryString.length != 0) {
        finalUrl += "?" + queryString.join("&");
      }
    }
    //header
    let userInfo = Utility.User.getUser(),
        _terminal = 'H5',
        _deviceType = 'H5' ,
        _partnerId = '',
        _loginTokenType = '',
        _loginToken = '',
        _deviceId =  'zs-no-finger-print',
        _lang = Utility.getLang();

        let urlObj = Utility.getSearchParams();
        // 设备ID
        if(urlObj.deviceId) {
          _deviceId = urlObj.deviceId
        } else if(fingerPrint.getFingerPrintObj() && fingerPrint.getFingerPrintObj().finger) {
          _deviceId = fingerPrint.getFingerPrintObj().finger;
        }

        //login type
        _loginTokenType = userInfo.loginTokenType;
        if(!_loginTokenType) {
          _loginTokenType="LOGIN_TOKEN";
        }
        let urlLoginToken = urlObj.loginToken; //若url中拼有loginToken，则以此为准
        
       // login token
        _loginToken = urlLoginToken || userInfo.token;
        if(!_loginToken) {
          _loginToken = "";
        }
        
        //设备类型
        if (urlObj.deviceType) {
          _deviceType = urlObj.deviceType;
        }

        //终端
        if (urlObj.terminal) {
          _terminal = urlObj.terminal;
        }

        //语言
        if(urlObj.language) {
          _lang = urlObj.language;
        }

        console.log('ddddd',_lang)

    var opt = {
      type: method,
      dataType: "json",
      url: finalUrl,
      headers: { "Content-Type": "application/json"},
      timeout: 20000,
      xhrFields: {
        // 跨域允许带上 cookie
        // withCredentials: true
      }
    };
    // let userInfo = Utility.Cookie.getValue("UserInfo");
    let gateway = {
      bizContent: postdata,
      loginAuthInfo: {
        isEnt: "",
        loginToken: _loginToken,
        loginTokenType: _loginTokenType,
        operatorId: "",
        operatorName: "",
        partnerId: _partnerId
      },
      requestNo: `requestno${new Date().getTime()}${parseInt(
        Math.random() * 1000000
      )}`,
      sarsTokenId: window.blackbox ? window.blackbox : "",
      service: service,
      sign: "",
      signType: "AES",
      language: _lang,
      terminalInfo:{
        "appVersion": require('../../package.json').version,
        "deviceBrand": "",
        "deviceId": _deviceId,
        "deviceModel": "",
        "deviceType": _deviceType,
        "deviceVersion": "",
        "terminal": _terminal,
        "userNetType": ""
      },
      timestamp: new Date().getTime(),
      version:params.version ? params.version : "1.0.0"
    };
    if (postdata) {
      opt.data = JSON.stringify(gateway);
    }

    $.support.cors = true;

    
    let tmp = $.ajax(opt)
      // .done(defer.resolve)
      .then(response => {
        Toast.hide();
        $(".modal-cover").remove();
      if (response.code === "AGW20001") {
        Toast.hide();
        Toast.info(response.message, 2);
        let _loginUrl = userInfo.loginUrl;

        setTimeout(function() {
          var uAgent = navigator.userAgent.toLowerCase();
          if (
            /iphone|ipad|ipod/.test(uAgent) &&
            typeof goAuthorize === "function"
          ) {
            goAuthorize();
          } else if (
            /android/.test(uAgent) &&
            typeof goAuthorize === "function"
          ) {
            goAuthorize();
          } else if (_loginUrl) {
            Toast.loading("", 0);
            location.href = _loginUrl;
          } else {
            let params = {
              type: "TokenLose", // type: 消息类型,必传
              messag: "MessageData" // 消息数据
            };
            // 发送消息给RN,postMessage()只能接受字符串
            window.postMessage(JSON.stringify(params)); // 发送消息到rn
          }
        }, 2000);
        return false;

        } 
       
        if (needStatus) {
          deferred.resolve(response);
        } else {
          if (response.code !== "S0001") {
            if (response.subMsg) {
              Toast.info(response.subMsg, 2);
            } else if (response.msg) {
              Toast.info(response.msg, 2);
            }
            return false;
          }
          deferred.resolve(response.bizContent);
        }
        
      })
      .fail(function(err) {
        $(".modal-cover").remove();
        Toast.info('网络异常,请求错误。。。。', 1);
        service = "";
      });
    return deferred.promise();
  }
}

export default new GatewayApiService().apiServiceMethod;



// WEBPACK FOOTER //
// ./src/service/apiGatewayService.js